/*
 * @Author: cc
 * @Date: 2019-10-29 15:55:07
 * @LastEditTime: 2022-01-20 15:00:33
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\kuaishou\draftBox\draftBox.js
 * @Description:  抖音废稿箱待编
 */
'use strict';

angular.module('editKuaishouDraftBoxModule', [])
    .controller('EditKuaishouDraftBoxCtrl', [
        '$scope',
        '$state',
        '$controller',
        'modalDialog',
        'trsHttpService',
        'KuaishouConst',
        'trsspliceString',
        'editingMediatype',
        function(
            $scope,
            $state,
            $controller,
            modalDialog,
            trsHttpService,
            KuaishouConst,
            trsspliceString,
            editingMediatype
        ) {
            initStatus();

            /**
             * [initStatus description]初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.trenchStatus = {
                    mediaType: editingMediatype.kuaishou, // 后端需要的mediaType
                    // eslint-disable-next-line camelcase
                    status_model: -1, // 后台用来区分待编、待审、已签发、废稿箱
                    accountKey: 'accountId', // 需要区分一下不同渠道的账号ID
                };
                $scope.trenchParams = {
                    serviceid: 'mlf_kuaishou',
                    methodName: 'queryRecycleDoc',
                    // kuaiShouAccountId: $state.params.account,
                };
                $scope.trenchData = {
                    trench: 'kuaishou', // 表明当前渠道，用来区分渠道，并给以前写好的操作按钮方法
                    trenchConst: KuaishouConst, // 渠道需要的常量
                };
                $scope.trenchRightsParams = {
                    methodname: 'queryOperKeyOfKuaishou',
                    Classify: 'kuaishou.recyclemgr',
                    accountId: $state.params.account,
                };
                $controller('EditShortVideoListCtrl', {$scope: $scope}); // 控制器继承
            }

            /**
             * [restore description]稿件还原
             * @return {[type]} [description]
             */
            $scope.restore = function() {
                modalDialog.confirmModal('', '确定还原？', function() {
                    var params = {
                        serviceid: 'mlf_kuaishou',
                        methodName: 'restoreMetaDatas',
                        accountId: $state.params.account,
                        DocIds: trsspliceString.spliceString($scope.data.selectedArray, 'KUAISHOUARTICLEID', ','),
                    };
                    $scope.status.isSearch = false;
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                        modalDialog.alertType('还原稿件成功', '', 'success', false);
                        $scope.requestData();
                    });
                });
            };

            /**
             * [delete description]稿件删除
             * @return {[type]} [description]
             */
            $scope.delete = function() {
                modalDialog.confirmModal('', '确定删除？', function() {
                    var params = {
                        serviceid: 'mlf_kuaishou',
                        methodName: 'deleteMetaDatas',
                        accountId: $state.params.account,
                        DocIds: trsspliceString.spliceString($scope.data.selectedArray, 'KUAISHOUARTICLEID', ','),
                    };
                    $scope.status.isSearch = false;
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                        modalDialog.alertType('删除稿件成功', '', 'success', false);
                        $scope.requestData();
                    });
                });
            };

            /**
             * [clearTrash description]清空废稿箱
             * @return {[type]} [description]
             */
            $scope.clearTrash = function() {
                modalDialog.confirmModal('', '确定清空？', function() {
                    var params = {
                        serviceid: 'mlf_kuaishou',
                        methodName: 'clearRecycleDoc',
                        accountId: $state.params.account,
                    };
                    $scope.status.isSearch = false;
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(
                        function() {
                            modalDialog.alertType('', '清空废稿箱成功', 'success');
                            $scope.requestData();
                        },
                        function(data) {
                            modalDialog.alertType('', '清空废稿箱失败', 'error');
                        }
                    );
                });
            };
        },
    ]);
